import { makeAutoObservable } from "mobx";
import * as KeyNames from 'src/utils/KeyNames'

export default class UserStore {

  accessToken: string | null = null;
  loginAccount: any | null = null;

  myWholesaler: any = null;       // For Customer, If he has multiple wholesaler, which one is my target...
  selectedCustomer: any = null;   // For Wholesaler, Customers Dropdown list at Sales Order...

  webVersion: string = '';
  lastRequestBody: string = '';


  constructor() {

    makeAutoObservable(this);
    console.log("isTesting: " + process.env.REACT_APP_IS_TESTING + ", Login Redirect: " + process.env.REACT_APP_LOGIN_REDIRECT + 
             ", API URL: " + process.env.REACT_APP_API_URL);
  }

  initAuth() {

    console.log("UsrStore.initAuth() called...")

    this.accessToken = window.localStorage.getItem( KeyNames.STORAGE_TOKEN );

    const tempLogin = window.localStorage.getItem( KeyNames.STORAGE_ACCOUNT );
    if (tempLogin) {
      this.loginAccount = JSON.parse(tempLogin);
    }
  }

  logout = () => {

    window.localStorage.removeItem( KeyNames.STORAGE_TOKEN );
    window.localStorage.removeItem( KeyNames.STORAGE_ACCOUNT );

    // clear session storage caches....
    window.sessionStorage.clear();

    this.accessToken = null;
    this.loginAccount = null;

    // Delete caches...
    if ('caches' in window) {
      caches.keys().then((names) => {
          names.forEach(async (name) => {
              await caches.delete(name)
          })
      });
    }

    window.location.replace(process.env.REACT_APP_LOGIN_REDIRECT);
  }
  
  setLoginAccount = async(value: any, byForce: boolean = false)  => {

    console.log("setloginAccount called, loginAccount: " + (this.loginAccount ? "already set " : "null, byForce: ") + byForce);

    if (this.loginAccount === null || byForce === true) {
      
      this.loginAccount = value;
      window.localStorage.setItem( KeyNames.STORAGE_ACCOUNT, JSON.stringify(value) );
    }
  }

  get isAuthenticated() {
 
    if (this.loginAccount && this.loginAccount.email) {
      return true;
    }

    return false;
  }

  get isSystemAdmin() {

    if (this.loginAccount.email === "admin@melsaesoon.org") {
      return true;
    }

    return false;
  }


  setAccessToken(value: string | null) {
    this.accessToken = value;

    window.localStorage.setItem( KeyNames.STORAGE_TOKEN, value);
  }

  setMyWholesaler(value: any) {
    this.myWholesaler = value;
  }

  setSelectedCustomer(value: any) { // For Wholesaler, Customers Dropdown list at Sales Order...
    this.selectedCustomer = value;
  }

  setWebVersion(value: string) {
    this.webVersion = value;
  }
  
  setLastRequestBody(value: string) {
    this.lastRequestBody = value;
  }

}